var _path, _path2, _path3, _path4, _g, _path5, _g2, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoLocalsearch = function SvgLogoLocalsearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 229 46"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m34.772 31.15-3.173 3.173c-8.375 8.282-16.75 0-16.75 0l-3.172-3.172c-8.375-8.282 0-16.54 0-16.54l3.173-3.173c8.375-8.281 16.75 0 16.75 0l3.172 3.173c8.351 8.258 0 16.54 0 16.54"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M23.038 28.934a6.436 6.436 0 0 0 6.438-6.438c0-3.546-2.893-6.439-6.438-6.439s-6.439 2.893-6.439 6.439c-.116 3.546 2.776 6.438 6.439 6.438"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M41.21 12.395 33.605 4.79s-10.684-10.684-21.251 0l-7.512 7.605s-10.684 10.59 0 21.252l7.605 7.605s10.684 10.684 21.252 0l7.605-7.605c-.094 0 10.59-10.568-.094-21.252M33.91 30.87l-2.986 2.986c-7.885 7.884-15.77 0-15.77 0l-2.986-2.986c-7.885-7.885 0-15.77 0-15.77l2.986-2.986c7.885-7.885 15.77 0 15.77 0l2.986 2.986c7.885 7.861 0 15.77 0 15.77"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "d",
    width: 46,
    height: 46,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M41.21 12.395 33.605 4.79s-10.684-10.777-21.345 0L4.75 12.395s-10.685 10.59 0 21.252l7.604 7.605s10.685 10.684 21.252 0l7.605-7.605c0 .093 10.684-10.568 0-21.252M34.375 30.38l-3.266 3.359c-7.885 7.885-15.303.583-15.303.583l-3.85-3.662c-7.884-7.792.188-15.583.094-15.677l2.986-2.986c7.885-7.791 15.77 0 15.77 0l2.986 2.986c7.908 7.978.583 15.397.583 15.397"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M33.792 35.186C23.41 45.38 13.005 35 13.005 35c-2.216.77-4.432.77-6.345.373l5.972 5.878s10.59 10.475 21.065 0l7.512-7.511s2.986-2.986 4.129-7.302l-4.432 4.433c-2.497 2.496-4.806 3.732-7.115 4.315"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M30.526 18.74c-.187 6.159-4.713 10.684-4.713 10.684L23.9 31.337c1.727 1.05 4.433 2.123 7.419 1.633l2.31-2.31s1.632-1.726 2.682-4.222c-.49-1.633-1.447-3.359-3.173-5.109z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M18.792.568c.093-.094.187-.094.187-.187-.28.093-.49.187-.77.187l.28.28z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "m18.606 37.216-.28.28c-2.683 2.892-3.453 3.266-3.453 3.266 1.353 1.143 7.115 5.972 13.554 1.353-5.482-.677-9.518-4.62-9.518-4.62z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66C5E3",
    d: "M.223 25.668c1.353-4.129 4.222-6.741 4.222-6.741l3.08-3.08c1.26-4.432 4.222-7.418 4.222-7.418l2.03-2.03c-.49-.28-1.144-.676-1.82-.956l-7.022 7.022c-.093.023-6.042 5.785-4.712 13.203",
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "m23.69 6.05.584.583c4.992.956 8.561 4.525 8.561 4.525l7.605 7.605c1.143 1.143 2.123 2.403 2.8 3.57a9.5 9.5 0 0 0 .093-6.929c-.677-.956-1.447-2.03-2.497-2.986l-6.461-6.765c-2.59-1.446-6.625-2.31-10.685.397",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M12.05 30.87c-1.446-1.446-2.589-3.755-3.172-5.108l-.093.28c-.77 2.03-1.05 4.619.093 7.301 1.353-.093 2.59-.676 4.036-1.54z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "m30.526 18.74 2.59 2.59c1.725 1.726 2.682 3.452 3.172 5.108 1.26-2.985 1.54-7.301-2.683-11.547l-2.986-2.986s-1.353-1.353-3.36-2.31c2.404 3.173 3.267 6.346 3.267 9.145",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M21.195 14.798c-.584-1.26-1.447-2.59-2.8-3.943-.186.187-2.799 2.893-3.359 6.649 2.216-1.843 4.246-2.52 6.159-2.706",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M28.8 41.835c-7.302 5.295-14.044-1.54-14.044-1.54l-.093-.093c-.77.373-1.54.77-2.31.956 0 0 10.475 10.474 21.066.187-1.54.583-3.173.676-4.62.49"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M8.785 33.273c-1.144-2.683-.864-5.295-.094-7.301-1.913-1.913-3.172-4.992-2.403-9.052 0 0-5.108 4.223-6.158 8.748.373 2.03 1.353 4.223 3.08 6.439 1.632.77 3.475 1.353 5.575 1.166",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M27.657 9.899c2.122 1.05 3.359 2.31 3.359 2.31l2.986 2.985c4.222 4.222 3.942 8.468 2.682 11.547.374 1.447.374 2.8.187 4.036.28-.28.583-.49.863-.77l2.986-2.986s1.726-1.726 2.8-4.525c-.677-1.143-1.634-2.31-2.8-3.57l-7.605-7.604s-4.129-3.85-9.144-4.806v.093l.28.094.186.093c1.377.98 2.823 2.613 3.22 3.103",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "m11.188 29.424 2.029 2.03c.77-.49 1.446-1.05 2.216-1.82l2.986-2.986c-3.172-3.266-3.849-6.438-3.36-9.144",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "m23.808 31.43-5.016 5.016c2.986 1.26 7.302 1.726 11.64-2.683l.677-.676c-2.893.466-5.575-.584-7.302-1.657",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "m18.512.848 5.202 5.202c4.036-2.683 8.188-1.82 10.684-.49l-1.05-1.05S26.91-1.742 19.025.381c-.093.093-.187.093-.187.187z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#s)",
    d: "m5.519 16.92 5.972-5.878c1.353-1.353 2.683-2.403 4.036-3.08l-.094-.093s-1.82-1.726-3.662-2.402L7.92 9.596c0-.094-2.985 2.986-2.402 7.325"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#t)",
    d: "M31.016 33.95c-4.34 4.339-8.655 3.942-11.64 2.682l-.374-.093.373.77s3.943 3.943 9.518 4.619c.583-.373 1.143-.863 1.726-1.54l2.986-2.986s2.8-2.799 3.36-6.648c-1.82 1.54-3.57 2.31-5.203 2.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#u)",
    d: "M43.427 22.59c.956 1.539 1.726 2.892 2.03 4.338 1.049-3.172 1.142-7.208-1.634-11.36.84 2.496.28 5.085-.396 7.021"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#v)",
    d: "M14.173 18.25c.28-.28.583-.583.863-.77.583-3.756 3.173-6.438 3.36-6.648l-1.05-1.05c-.864.49-1.82 1.26-2.683 2.123l-2.986 2.986S7.15 20.093 8.784 25.948c1.05-2.59 2.403-4.712 2.403-4.712z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#w)",
    d: "M14.173 18.25c.28-.28.583-.583.863-.77.583-3.756 3.173-6.438 3.36-6.648l-1.05-1.05c-.864.49-1.82 1.26-2.683 2.123l-2.986 2.986S7.15 20.093 8.784 25.948c1.05-2.59 2.403-4.712 2.403-4.712z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#x)",
    d: "m11.677 14.984 2.986-2.986c.863-.863 1.82-1.633 2.683-2.123l-1.82-1.82a18.6 18.6 0 0 0-4.035 3.08l-4.526 4.526c-.863 2.986.863 7.978 1.82 10.1-1.633-4.991 2.892-10.777 2.892-10.777",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#y)",
    d: "m11.584 14.984 3.662-3.662c.584-.677 2.123-1.54 2.123-1.54l-1.82-1.82c-1.352.77-2.985 1.82-4.338 3.267l-4.526 4.525c-1.913 6.649 2.03 10.288 2.123 10.288-1.656-5.856 2.776-11.058 2.776-11.058",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#z)",
    d: "m11.863 14.984 3.08-3.079c.863-.863 1.54-1.633 2.496-2.123l-1.82-1.82c-1.353.77-2.403 1.727-3.849 3.08l-4.526 4.526c-1.143 6.345 1.54 10.007 1.54 10.007-1.633-5.785 3.08-10.59 3.08-10.59",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#A)",
    d: "m18.512 26.625 3.079 3.08s.863.862 2.31 1.725l1.912-1.912s4.526-4.526 4.713-10.685l-.49-.49s-3.85-3.849-8.748-3.452c2.613 6.158-2.59 11.547-2.776 11.734",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6EC7E0",
    d: "m24.18 6.516-.489-.49c-.187.094-.28.187-.49.374.303.023.607.116.98.116"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#B)",
    d: "m18.792 36.446-1.143-.677c-1.82-.956-2.496-1.82-2.496-1.82l-2.216-2.215c-1.446.863-2.683 1.446-4.036 1.54.584 1.259 1.82 2.985 3.08 4.338l2.799 2.683c1.26-.863 2.123-1.913 3.453-3.266z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#C)",
    d: "M11.398 5.187c.676.28 1.26.583 1.819.956L18.512.848l-.28-.28c-2.029.676-4.128 1.913-6.251 4.035z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#45ADD0",
    d: "m21.498 7.87-.677.676c2.403-.373 5.296.373 6.439 1.05-.373-.49-.957-.957-1.447-1.447L24.18 6.516c-.28-.093-.676-.093-.956-.186-.583.49-1.166.956-1.726 1.54"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#65C4F0",
    d: "M20.611 8.826c1.727-.584 4.433-.094 5.762.373.49.186 1.05.373 1.143.49-1.05-1.447-2.799-2.893-2.799-2.893-.28-.187-1.05-.373-1.446-.373-1.12.676-2.66 2.403-2.66 2.403",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#D)",
    d: "M11.49 37.123c-1.353-1.353-2.122-2.497-2.589-3.85-2.123.094-4.036-.49-5.482-1.26.373.584.77.957 1.26 1.447l7.791 7.791c.77-.28 1.54-.583 2.31-.956z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#E)",
    d: "M11.864 37.496c-1.354-1.353-2.497-2.893-2.986-4.223-2.123.094-4.036-.49-5.482-1.143.373.584.77.957 1.26 1.447l7.79 7.791c.77-.28 1.54-.583 2.31-.956z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8FD1E7",
    d: "M15.526 7.963c2.683-1.447 5.295-1.82 7.605-1.54.186-.093.28-.28.49-.373L18.419.848l-5.296 5.295c1.446.863 2.216 1.726 2.216 1.726z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#F)",
    d: "M15.527 7.963c2.682-1.447 5.295-1.82 7.604-1.54.187-.093.28-.28.49-.373L17.16-6.944l-5.761 12.13c1.446.864 3.942 2.683 3.942 2.683z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#G)",
    d: "m18.512 10.855 2.31-2.31c-1.05.187-2.217.584-3.36 1.26z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#H)",
    d: "m20.822 8.546.676-.677c.583-.583 1.05-1.05 1.633-1.446-2.31-.28-4.899.093-7.605 1.54l1.82 1.82c1.26-.654 2.31-1.05 3.476-1.237"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DC8F2",
    d: "m20.612 8.826 1.05-1.05c.49-.49 1.05-.956 1.632-1.353-2.216-.28-5.108.187-7.604 1.54l2.029 2.122c.98-.676 1.843-.956 2.893-1.26"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#I)",
    d: "m13.216 25.179-2.122-2.31c-6.649-7.208 0-14.323 0-14.323l2.496-2.8c3.662-3.942 7.301-3.569 9.82-2.402l.49-.49C25.628.94 27.47-.226 29.197-.902c0 0-8.958-9.704-17.8 0L5.053 6.026s-8.958 9.705 0 19.34l6.345 6.928s2.986 3.172 7.208 4.035l-1.353-1.446c-3.172-3.36-4.129-6.719-4.036-9.705",
    opacity: 0.8
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "J",
    width: 14,
    height: 13,
    x: 16,
    y: 16,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.92 28.934a6.436 6.436 0 0 0 6.44-6.438c0-3.546-2.893-6.439-6.44-6.439-3.545 0-6.438 2.893-6.438 6.439s2.893 6.438 6.439 6.438"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#J)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#K)",
    d: "M24.764 21.05c-.583-1.26-1.446-2.59-2.8-3.943-.186.187-2.799 2.893-3.358 6.648 2.216-1.842 4.222-2.612 6.158-2.706",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#L)",
    d: "M16.786 37.682c.77-.49 1.447-1.05 2.217-1.82l2.986-2.985c-3.173-3.266-3.85-6.439-3.36-9.145-.28.28-.583.49-.863.77l-3.01 2.986s-1.632 1.726-2.682 4.222c.094.28.187.677.28.957a23.5 23.5 0 0 0 2.403 2.892z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#M)",
    d: "M17.742 24.502c.28-.28.584-.583.864-.77.583-3.755 3.172-6.438 3.359-6.648l-1.05-1.05c-.863.49-2.03.863-2.893 1.82l-2.799 3.359s-4.805 4.805-3.173 10.684c1.05-2.59 2.683-4.222 2.683-4.222z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#N)",
    d: "M17.743 24.502c.28-.28.583-.583.863-.77.583-3.755 3.172-6.438 3.359-6.648l-1.05-1.05c-.863.49-1.82.863-2.683 1.82l-2.986 3.359s-4.805 4.805-3.172 10.684c1.05-2.59 2.683-4.222 2.683-4.222z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#O)",
    d: "m22.059 32.877 3.079 3.08s.863.862 2.31 1.725l1.912-1.913s4.526-4.525 4.712-10.684l-.49-.49s-3.849-3.849-8.747-3.452c2.612 6.159-2.567 11.547-2.776 11.734"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#P)",
    d: "M22.059 17.107c1.353 1.353 2.216 2.683 2.799 3.942 4.992-.28 8.748 3.453 8.748 3.453l.49.49c.093-2.8-.77-5.972-3.453-9.145-1.633-.863-3.849-1.446-6.252-1.05z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Q)",
    d: "m22.059 17.107 2.309-2.31c-1.05.187-2.216.584-3.36 1.26z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#R)",
    d: "m22.059 17.107 2.309-2.31c-1.05.187-2.216.584-3.36 1.26z",
    opacity: 0.6
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#003B5C",
    d: "M62.75 35.132h-1.746c-.817 0-1.042-.227-1.042-1.048V11.548c0-.822.225-1.048 1.042-1.048h1.746c.817 0 1.043.226 1.043 1.048v22.536c.028.821-.226 1.048-1.043 1.048m12.675-17.639c4.986 0 7.55 2.577 7.55 6.654v4.671c0 4.077-2.677 6.654-7.55 6.654s-7.548-2.577-7.548-6.654v-4.671c0-4.077 2.676-6.654 7.548-6.654m0 3.511c-2.45 0-3.718 1.16-3.718 3.143v4.671c0 1.982 1.38 3.143 3.718 3.143 2.45 0 3.718-1.16 3.718-3.143v-4.671c.113-1.982-1.267-3.143-3.718-3.143m18.703-3.51c3.943 0 6.281 1.868 7.098 4.331.225.821 0 1.274-.704 1.529l-1.38.453c-.817.34-1.155.113-1.521-.708-.592-1.387-1.634-2.208-3.606-2.208-2.45 0-3.605 1.16-3.605 3.256v4.671c0 2.095 1.268 3.256 3.605 3.256 1.972 0 3.014-.82 3.606-2.321.338-.822.591-.935 1.52-.708l1.522.453c.817.34 1.042.708.704 1.529-1.042 2.803-3.38 4.445-7.323 4.445-4.986 0-7.324-2.577-7.324-6.767V24.26c-.253-4.077 2.17-6.767 7.408-6.767m17.182 0c5.464 0 7.098 2.915 7.098 6.766v8.409c0 1.16-.226 1.529-1.155 1.868-1.268.595-3.239.935-5.915.935-5.802 0-7.323-1.982-7.323-5.38 0-3.85 2.197-5.124 7.436-5.124 1.267 0 2.563.113 3.126.113v-1.048c0-2.095-.817-3.256-3.239-3.256-1.634 0-2.789.595-3.493 1.643-.45.707-.704.82-1.38.453l-1.267-.595c-.817-.34-.93-.708-.592-1.529 1.014-1.84 3.211-3.256 6.704-3.256m-.338 10.532c-2.563 0-3.127.82-3.127 2.208 0 1.274.592 2.208 3.127 2.208 1.746 0 2.676-.226 3.239-.34.338-.113.338-.113.338-.452v-3.511c-.676 0-2.31-.113-3.577-.113m14.506 7.106h-1.747c-.817 0-1.042-.227-1.042-1.048V11.548c0-.822.225-1.048 1.042-1.048h1.747c.816 0 1.042.226 1.042 1.048v22.536c0 .821-.226 1.048-1.042 1.048m11.858-17.639c3.83 0 6.027 1.388 7.098 3.511.338.821.112 1.16-.592 1.529l-1.521.594c-.817.34-.929.227-1.38-.453-.591-1.047-1.38-1.755-3.605-1.755s-3.127.595-3.127 1.869c0 1.529 1.268 1.755 3.831 1.982 3.943.34 6.732 1.274 6.732 5.124 0 3.256-2.451 5.606-7.211 5.606-3.831 0-6.281-1.387-7.323-3.964-.338-.708-.113-1.16.591-1.387l1.521-.453c.704-.227 1.042-.113 1.38.595.592 1.274 1.747 1.868 3.718 1.868 2.31 0 3.493-.708 3.493-1.982 0-1.529-1.267-1.868-3.943-2.095-3.239-.34-6.732-.821-6.732-5.125.225-3.227 2.535-5.464 7.07-5.464m18.224 0c5.239 0 7.661 3.03 7.661 6.767v1.982c0 .82-.338 1.387-1.521 1.387h-9.971v1.16c0 2.21 1.38 3.257 3.718 3.257 1.972 0 3.239-.708 3.943-1.755.592-.708.93-.822 1.747-.34l1.154.594c.817.34.817.935.338 1.642-1.154 1.982-3.38 3.143-7.098 3.143-5.464 0-7.548-3.03-7.548-7.135v-3.85c-.085-4.275 2.591-6.852 7.577-6.852m0 3.285c-2.451 0-3.831 1.274-3.831 3.255v.822h7.661v-.708c0-2.095-1.38-3.37-3.83-3.37m17.885-3.285c5.465 0 7.098 2.916 7.098 6.767v8.409c0 1.16-.225 1.529-1.154 1.868-1.268.595-3.24.935-5.915.935-5.803 0-7.324-1.982-7.324-5.38 0-3.85 2.197-5.124 7.436-5.124 1.268 0 2.563.113 3.127.113v-1.048c0-2.095-.817-3.256-3.239-3.256-1.634 0-2.789.595-3.493 1.643-.451.707-.704.82-1.38.453l-1.268-.595c-.817-.34-.929-.708-.591-1.529 1.014-1.84 3.239-3.256 6.703-3.256m-.338 10.533c-2.563 0-3.126.82-3.126 2.208 0 1.274.591 2.208 3.126 2.208 1.747 0 2.676-.226 3.24-.34.338-.113.338-.113.338-.452v-3.511c-.676 0-2.31-.113-3.578-.113m20.083-10.533c.817 0 1.042.227 1.042 1.048v1.529c0 .82-.225 1.047-1.042 1.047h-1.155q-1.9 0-3.126.34-.338.17-.338.34v12.146c0 .82-.225 1.047-1.042 1.047h-1.747c-.816 0-1.042-.226-1.042-1.047V20.409c0-1.047.226-1.528 1.268-1.868 1.267-.453 3.126-.934 6.168-1.048zm10.478 0c3.944 0 6.281 1.869 7.098 4.332.226.821 0 1.274-.704 1.529l-1.38.453c-.817.34-1.155.113-1.521-.708-.592-1.387-1.634-2.208-3.605-2.208-2.451 0-3.606 1.16-3.606 3.256v4.671c0 2.095 1.268 3.256 3.606 3.256 1.971 0 3.013-.82 3.605-2.321.338-.822.591-.935 1.521-.708l1.521.453c.817.34 1.042.708.704 1.529-1.042 2.803-3.38 4.445-7.323 4.445-4.986 0-7.324-2.577-7.324-6.767V24.26c-.169-4.077 2.169-6.767 7.408-6.767m14.506-5.945v6.54c1.042-.227 2.197-.453 3.943-.453 4.761 0 6.845 2.463 6.845 6.653v9.796c0 .821-.225 1.048-1.042 1.048h-1.859c-.817 0-1.042-.227-1.042-1.048v-9.683c0-2.095-1.268-3.256-3.606-3.256-1.633 0-3.126.34-3.38.454v12.485c0 .821-.225 1.048-1.042 1.048h-1.746c-.817 0-1.042-.227-1.042-1.048V11.548c0-.822.225-1.048 1.042-1.048h1.746c.958 0 1.183.226 1.183 1.048"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 18.651,
    x2: 26.484,
    y1: 15.422,
    y2: 28.169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.153,
    stopColor: "#00B4EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#05395C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2051D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 12.578,
    x2: 34.764,
    y1: 6.013,
    y2: 42.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.118,
    stopColor: "#00A7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    stopColor: "#008FC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.391,
    stopColor: "#00527E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#003A60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.592,
    stopColor: "#4B2947"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.718,
    stopColor: "#8C1A30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824,
    stopColor: "#BA0F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    stopColor: "#D70817"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.952,
    stopColor: "#E20613"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 4.862,
    x2: 34.871,
    y1: 5.706,
    y2: 41.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.021,
    stopColor: "#9D0C26",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#A81428",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489,
    stopColor: "#C72A2D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757,
    stopColor: "#E74133",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.827,
    stopColor: "#E73E31",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886,
    stopColor: "#E6332C",
    stopOpacity: 0.533
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.941,
    stopColor: "#E42222",
    stopOpacity: 0.758
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993,
    stopColor: "#E20A15",
    stopOpacity: 0.973
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E20613"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 23.784,
    x2: 36.193,
    y1: 25.918,
    y2: 25.918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553,
    stopColor: "#FFF6F4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856,
    stopColor: "#FFF8F6",
    stopOpacity: 0.678
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.981,
    stopColor: "#FFFDFD",
    stopOpacity: 0.958
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 19.248,
    x2: 41.435,
    y1: 1.513,
    y2: 37.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553,
    stopColor: "#FFF6F4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856,
    stopColor: "#FFF8F6",
    stopOpacity: 0.678
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.981,
    stopColor: "#FFFDFD",
    stopOpacity: 0.958
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 3.416,
    x2: 25.603,
    y1: 11.796,
    y2: 47.904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7C1B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#F29A9A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733,
    stopColor: "#F29A98",
    stopOpacity: 0.395
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.805,
    stopColor: "#F29991",
    stopOpacity: 0.558
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.858,
    stopColor: "#F29985",
    stopOpacity: 0.678
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.902,
    stopColor: "#F29773",
    stopOpacity: 0.777
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#F2965C",
    stopOpacity: 0.863
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973,
    stopColor: "#F29441",
    stopOpacity: 0.939
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F29224"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 25.496,
    x2: 47.723,
    y1: -2.34,
    y2: 33.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4EBFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.095,
    stopColor: "#50BCDC",
    stopOpacity: 0.811
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179,
    stopColor: "#58B1D2",
    stopOpacity: 0.643
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#649FC0",
    stopOpacity: 0.483
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.337,
    stopColor: "#7585A6",
    stopOpacity: 0.328
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.413,
    stopColor: "#8A6585",
    stopOpacity: 0.177
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#A53D5D",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#AB3454",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#DE091E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: -0.438,
    x2: 21.322,
    y1: 14.129,
    y2: 49.541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A77A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.556,
    stopColor: "#ADDCED",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#ABDAEB",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.788,
    stopColor: "#A4D3E5",
    stopOpacity: 0.522
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.838,
    stopColor: "#98C8DB",
    stopOpacity: 0.634
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879,
    stopColor: "#86B7CB",
    stopOpacity: 0.727
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.915,
    stopColor: "#6FA1B8",
    stopOpacity: 0.807
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.947,
    stopColor: "#5386A0",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#326783",
    stopOpacity: 0.944
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F4565"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 24.619,
    x2: 46.805,
    y1: 4.31,
    y2: 40.418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553,
    stopColor: "#FFF6F4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856,
    stopColor: "#FFF8F6",
    stopOpacity: 0.678
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.981,
    stopColor: "#FFFDFD",
    stopOpacity: 0.958
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 14.663,
    x2: 36.849,
    y1: 10.428,
    y2: 46.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553,
    stopColor: "#FFF6F4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856,
    stopColor: "#FFF8F6",
    stopOpacity: 0.678
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.981,
    stopColor: "#FFFDFD",
    stopOpacity: 0.958
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 7.119,
    x2: 29.305,
    y1: 15.594,
    y2: 51.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E73374"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553,
    stopColor: "#D74B3F",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726,
    stopColor: "#D54A3E",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    stopColor: "#CE463B",
    stopOpacity: 0.637
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#C24036",
    stopOpacity: 0.731
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893,
    stopColor: "#B0382F",
    stopOpacity: 0.809
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.931,
    stopColor: "#992C26",
    stopOpacity: 0.876
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.965,
    stopColor: "#7D1E1B",
    stopOpacity: 0.937
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#5C0E0E",
    stopOpacity: 0.991
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#560B0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 1.595,
    x2: 23.012,
    y1: 19.49,
    y2: 54.346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADDCED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553,
    stopColor: "#ADDCED",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    stopColor: "#ADDCED",
    stopOpacity: 0.854
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADDCED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 25.957,
    x2: 48.585,
    y1: 3.448,
    y2: 40.273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55B7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    stopColor: "#59A7C7",
    stopOpacity: 0.906
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283,
    stopColor: "#637B9A",
    stopOpacity: 0.619
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    stopColor: "#6A5B7A",
    stopOpacity: 0.361
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634,
    stopColor: "#6E4766",
    stopOpacity: 0.146
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742,
    stopColor: "#70405F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804,
    stopColor: "#774266",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.896,
    stopColor: "#89487A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A55299",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 5.057,
    x2: 27.244,
    y1: 10.332,
    y2: 46.439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553,
    stopColor: "#FFF6F4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856,
    stopColor: "#FFF8F6",
    stopOpacity: 0.678
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.981,
    stopColor: "#FFFDFD",
    stopOpacity: 0.958
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 8.604,
    x2: 30.791,
    y1: 8.152,
    y2: 44.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553,
    stopColor: "#FFF6F4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856,
    stopColor: "#FFF8F6",
    stopOpacity: 0.678
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.981,
    stopColor: "#FFFDFD",
    stopOpacity: 0.958
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 23.761,
    x2: 45.989,
    y1: -1.159,
    y2: 35.016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#74C6E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553,
    stopColor: "#51B8E9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.889,
    stopColor: "#52B8E7",
    stopOpacity: 0.752
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53B8E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 5.446,
    x2: 15.536,
    y1: 11.188,
    y2: 11.188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC4F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464,
    stopColor: "#5DC5F1",
    stopOpacity: 0.768
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634,
    stopColor: "#64C7F2",
    stopOpacity: 0.683
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.756,
    stopColor: "#70CAF3",
    stopOpacity: 0.622
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855,
    stopColor: "#81D0F4",
    stopOpacity: 0.573
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.938,
    stopColor: "#96D6F6",
    stopOpacity: 0.531
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ACDDF8",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 10.868,
    x2: 33.753,
    y1: 5.87,
    y2: 43.114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E73374"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.569,
    stopColor: "#F5B0A5",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729,
    stopColor: "#F4AEA3",
    stopOpacity: 0.383
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#F2A79D",
    stopOpacity: 0.532
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.843,
    stopColor: "#EE9B91",
    stopOpacity: 0.642
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.883,
    stopColor: "#E98981",
    stopOpacity: 0.734
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918,
    stopColor: "#E2726C",
    stopOpacity: 0.813
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.949,
    stopColor: "#D95652",
    stopOpacity: 0.883
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976,
    stopColor: "#CF3535",
    stopOpacity: 0.946
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C41315"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 29.163,
    x2: 51.35,
    y1: -3.935,
    y2: 32.173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E73374"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553,
    stopColor: "#9A345E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#9B335C",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.894,
    stopColor: "#A02F55",
    stopOpacity: 0.762
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.967,
    stopColor: "#A82749",
    stopOpacity: 0.925
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD2240"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 10.307,
    x2: 33.742,
    y1: 13.043,
    y2: 51.183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553,
    stopColor: "#FFF6F4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856,
    stopColor: "#FFF8F6",
    stopOpacity: 0.678
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.981,
    stopColor: "#FFFDFD",
    stopOpacity: 0.958
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 7.48,
    x2: 30.916,
    y1: 8.444,
    y2: 46.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADDCED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553,
    stopColor: "#ADDCED",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    stopColor: "#ADDCED",
    stopOpacity: 0.854
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADDCED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 7.492,
    x2: 29.633,
    y1: 8.745,
    y2: 44.778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADDCED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553,
    stopColor: "#ADDCED",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    stopColor: "#ADDCED",
    stopOpacity: 0.854
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADDCED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 10.082,
    x2: 32.889,
    y1: 13.295,
    y2: 50.412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADDCED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553,
    stopColor: "#ADDCED",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    stopColor: "#ADDCED",
    stopOpacity: 0.854
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADDCED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 10.303,
    x2: 32.407,
    y1: 13.108,
    y2: 49.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACDDF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553,
    stopColor: "#ACDDF8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    stopColor: "#ACDDF8",
    stopOpacity: 0.854
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ACDDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 7.66,
    x2: 29.847,
    y1: -4.704,
    y2: 31.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553,
    stopColor: "#FFF6F4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856,
    stopColor: "#FFF8F6",
    stopOpacity: 0.678
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.981,
    stopColor: "#FFFDFD",
    stopOpacity: 0.958
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: -5.575,
    x2: 16.895,
    y1: 3.314,
    y2: 39.884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#013854"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#8A345F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.702,
    stopColor: "#8C335E",
    stopOpacity: 0.126
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.791,
    stopColor: "#932F59",
    stopOpacity: 0.178
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.857,
    stopColor: "#9F2950",
    stopOpacity: 0.217
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.912,
    stopColor: "#B11F44",
    stopOpacity: 0.248
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.958,
    stopColor: "#C71434",
    stopOpacity: 0.276
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E30521",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: 9.509,
    x2: 31.695,
    y1: -5.84,
    y2: 30.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADDCED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553,
    stopColor: "#ADDCED",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    stopColor: "#ADDCED",
    stopOpacity: 0.854
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADDCED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    x1: -3.51,
    x2: 18.904,
    y1: 15.664,
    y2: 52.141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADDCED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.551,
    stopColor: "#ADDCED",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#ADDCED",
    stopOpacity: 0.854
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADDCED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    x1: -9.512,
    x2: 12.85,
    y1: 5.991,
    y2: 42.385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005,
    stopColor: "#013854"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491,
    stopColor: "#8A345F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705,
    stopColor: "#8C335E",
    stopOpacity: 0.295
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#932F59",
    stopOpacity: 0.416
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859,
    stopColor: "#9F2950",
    stopOpacity: 0.506
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913,
    stopColor: "#B11F44",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.959,
    stopColor: "#C71434",
    stopOpacity: 0.643
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E30521",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    x1: 1.371,
    x2: 46.152,
    y1: -21.883,
    y2: 50.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7EDFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553,
    stopColor: "#ACDDF8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.763,
    stopColor: "#AEDEF8",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#B5E0F8",
    stopOpacity: 0.664
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914,
    stopColor: "#C1E5F8",
    stopOpacity: 0.807
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.966,
    stopColor: "#D3ECF8",
    stopOpacity: 0.924
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3F2F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    x1: 18.468,
    x2: 40.655,
    y1: 8.089,
    y2: 44.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553,
    stopColor: "#FFF6F4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856,
    stopColor: "#FFF8F6",
    stopOpacity: 0.678
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.981,
    stopColor: "#FFFDFD",
    stopOpacity: 0.958
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "H",
    x1: 16.768,
    x2: 38.955,
    y1: 3.036,
    y2: 39.144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADDCED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553,
    stopColor: "#ADDCED",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    stopColor: "#ADDCED",
    stopOpacity: 0.854
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADDCED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "I",
    x1: 11.53,
    x2: 26.248,
    y1: 3.023,
    y2: 28.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A0D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    stopColor: "#BCE3F9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "K",
    x1: 18.21,
    x2: 40.396,
    y1: 16.66,
    y2: 52.767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADDCED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553,
    stopColor: "#ADDCED",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    stopColor: "#ADDCED",
    stopOpacity: 0.854
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADDCED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "L",
    x1: 8.396,
    x2: 30.583,
    y1: 16.691,
    y2: 52.799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553,
    stopColor: "#FFF6F4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856,
    stopColor: "#FFF8F6",
    stopOpacity: 0.678
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.981,
    stopColor: "#FFFDFD",
    stopOpacity: 0.958
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "M",
    x1: 13.767,
    x2: 36.273,
    y1: 19.225,
    y2: 55.853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADDCED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553,
    stopColor: "#ADDCED",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    stopColor: "#ADDCED",
    stopOpacity: 0.854
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADDCED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "N",
    x1: 11.101,
    x2: 33.469,
    y1: 14.886,
    y2: 51.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADDCED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553,
    stopColor: "#ADDCED",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    stopColor: "#ADDCED",
    stopOpacity: 0.854
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADDCED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "O",
    x1: 11.208,
    x2: 33.394,
    y1: 1.528,
    y2: 37.636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E73374"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553,
    stopColor: "#824068",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#843F66",
    stopOpacity: 0.497
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867,
    stopColor: "#8B3A60",
    stopOpacity: 0.702
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#973154",
    stopOpacity: 0.853
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#A92544",
    stopOpacity: 0.977
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD2240"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    x1: 24.284,
    x2: 46.47,
    y1: 12.928,
    y2: 49.035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55B7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553,
    stopColor: "#55B7D7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    stopColor: "#55B7D7",
    stopOpacity: 0.854
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55B7D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Q",
    x1: 22.016,
    x2: 44.203,
    y1: 14.321,
    y2: 50.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADDCED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553,
    stopColor: "#ADDCED",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    stopColor: "#ADDCED",
    stopOpacity: 0.854
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADDCED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "R",
    x1: 13.347,
    x2: 35.534,
    y1: 0.213,
    y2: 36.321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55B7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553,
    stopColor: "#55B7D7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    stopColor: "#55B7D7",
    stopOpacity: 0.854
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55B7D7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h229v46H0z"
  })))));
};
export default SvgLogoLocalsearch;